import script from "./NetworkPerformance.vue?vue&type=script&setup=true&lang=js"
export * from "./NetworkPerformance.vue?vue&type=script&setup=true&lang=js"

import "./NetworkPerformance.vue?vue&type=style&index=0&id=981af29c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-981af29c"]])

export default __exports__